// extracted by mini-css-extract-plugin
export default {"wrapper":"rT-z","firstToReview":"sT-z","productCards":"tT-z","productCard":"uT-z","stars":"vT-z","hidden":"wT-z"};